import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useListServices } from '@/features/organization-services/api/list-services/list-services.hook';

interface AppointmentServiceSelectProps {
  id: string;
  value?: string;
  onValueChange: (value: string) => void;
  currentServiceName?: string;
}

export function AppointmentServiceSelect({
  id,
  value,
  onValueChange,
  currentServiceName,
}: AppointmentServiceSelectProps) {
  const { services, isLoading, isError } = useListServices();
  return (
    <>
      <Select
        value={value}
        onValueChange={onValueChange}
        disabled={isLoading || isError}
      >
        <SelectTrigger id={id}>
          <SelectValue
            placeholder={isLoading ? 'Loading services…' : 'Select service'}
          />
        </SelectTrigger>
        <SelectContent>
          {value && !services.some((service) => service.id === value) && (
            <SelectItem value={value}>
              {currentServiceName || 'Current service'}
            </SelectItem>
          )}
          {services.map((service) => (
            <SelectItem key={service.id} value={service.id}>
              {service.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {isError && (
        <p className="text-sm text-destructive">
          Could not load services. Close and reopen to try again.
        </p>
      )}
    </>
  );
}
